import { defineComponent as _defineComponent } from 'vue'
import BCXUserBannerSimple from '@/components/molecules/BCXUserBannerSimple.vue';
import { PropType } from 'vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { Contract } from '@/models/Contracts';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActionContractDetails',
  props: {
  contract: {
    type: Object as PropType<Contract>,
    required: true
  }
},
  setup(__props) {



const { getFormattedDate } = useFormattedDateTime();


return { __sfc: true,getFormattedDate, BCXUserBannerSimple }
}

})